export function onAcceptListener(sourceItemHandleScope, dest) {
  const destinationCategory = dest.sortableScope.modelValue[dest.index()];
  return (
    !sourceItemHandleScope.itemScope.modelValue.IsTemplateFolder &&
    !sourceItemHandleScope.itemScope.modelValue.IsSystemTemplate &&
    !destinationCategory.IsSystemTemplate
  );
}
